export const profileDefaults = {
    profileOf: "Profiel van",
};
export default profileDefaults;
